import store2 from "store2";
import { getInstanceConfig } from "./config";

export const useCreateFileUrl = () => {
    return createFileUrl;
};

const createFileUrl = (fileId: string, instanceToUse?: string) => {
    const { url, authKey } = getInstanceConfig(instanceToUse);
    const auth = store2.get(authKey);

    return `${url}/assets/${fileId}?&access_token=${auth.access_token}`;
};
